/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.848.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SidPricingOverride
 */
export interface SidPricingOverride {
    /**
     * 
     * @type {string}
     * @memberof SidPricingOverride
     */
    sId?: string;
    /**
     * 
     * @type {string}
     * @memberof SidPricingOverride
     */
    price?: string;
    /**
     * 
     * @type {string}
     * @memberof SidPricingOverride
     */
    date?: string;
    /**
     * 
     * @type {string}
     * @memberof SidPricingOverride
     */
    sid?: string;
}

/**
 * Check if a given object implements the SidPricingOverride interface.
 */
export function instanceOfSidPricingOverride(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SidPricingOverrideFromJSON(json: any): SidPricingOverride {
    return SidPricingOverrideFromJSONTyped(json, false);
}

export function SidPricingOverrideFromJSONTyped(json: any, ignoreDiscriminator: boolean): SidPricingOverride {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sId': !exists(json, 'sId') ? undefined : json['sId'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
    };
}

export function SidPricingOverrideToJSON(value?: SidPricingOverride | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sId': value.sId,
        'price': value.price,
        'date': value.date,
        'sid': value.sid,
    };
}

